"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButton = exports.RadioGroup = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("@rebass/forms/styled-components");

var _styledComponents2 = require("rebass/styled-components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RadioGroup = function RadioGroup(_ref) {
  var children = _ref.children,
      name = _ref.name,
      value = _ref.value,
      onChange = _ref.onChange,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'column' : _ref$direction,
      props = _objectWithoutProperties(_ref, ["children", "name", "value", "onChange", "direction"]);

  var _useState = (0, _react.useState)(value),
      _useState2 = _slicedToArray(_useState, 2),
      currentValue = _useState2[0],
      setCurrentValue = _useState2[1];

  var onChangeCallback = (0, _react.useCallback)(function (event) {
    setCurrentValue(event.target.value);
    onChange(event.target.value);
  }, [value]);
  return _react.default.createElement(_styledComponents2.Flex, _extends({
    flexDirection: direction
  }, props), _react.default.Children.map(children, function (child) {
    return !(child.type.name === RadioButton.name) ? child : _react.default.cloneElement(child, {
      name: name,
      checked: child.props.value === currentValue,
      onChange: onChangeCallback
    });
  }));
};

exports.RadioGroup = RadioGroup;
RadioGroup.propTypes = {
  children: _propTypes.default.node,
  onChange: _propTypes.default.func,
  value: _propTypes.default.string,
  name: _propTypes.default.string,
  direction: _propTypes.default.oneOf(['row', 'column'])
};

var RadioButton = function RadioButton(_ref2) {
  var label = _ref2.label,
      props = _objectWithoutProperties(_ref2, ["label"]);

  return _react.default.createElement(_styledComponents.Label, {
    htmlFor: props.id,
    alignItems: "center"
  }, _react.default.createElement(_styledComponents.Radio, props), label);
};

exports.RadioButton = RadioButton;
RadioButton.propTypes = {
  label: _propTypes.default.any,
  id: _propTypes.default.string
};